export const homeSliders_SongIT = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088490/483526791_648356701176984_167459529191352972_n_nfgtrf.jpg',
        title: 'Sóng IT 2025',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
]

export const SongIT_2021_2022 = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088479/484002924_648356951176959_965751540522382791_n_saotmw.jpg',
        title: 'SÓNG IT - TUYÊN DƯƠNG GƯƠNG ĐIỂN HÌNH TUỔI TRẺ CÔNG NGHỆ THÔNG TIN 2025',
        content:
            '🎉 Nhằm vinh danh các cá nhân, tập thể có nhiều đóng góp trong các lĩnh vực, hoạt động, Đoàn - Hội Khoa Công nghệ thông tin xin tổ chức chương trình "SÓNG IT - Tuyên dương Gương điển hình tuổi trẻ Công nghệ Thông tin 2025"...',
    }
]

export const awards_SongIT_2021_2022 = [
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235050/2021-2022/S%C3%B3ng%20IT/NTP_mvo68t.jpg',
            title: 'Nguyễn Trần Phúc',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235049/2021-2022/S%C3%B3ng%20IT/PTD_sgjwva.jpg',
            title: 'Phan Thành Đạt',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235048/2021-2022/S%C3%B3ng%20IT/PNTT_qboqiv.jpg',
            title: 'Phan Nguyễn Thanh Trúc',
        },
    ],
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235048/2021-2022/S%C3%B3ng%20IT/NHMT_svu3tr.jpg',
            title: 'Nguyễn Huỳnh Minh Tiến',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235048/2021-2022/S%C3%B3ng%20IT/NTT_doqgt4.jpg',
            title: 'Nguyễn Trung Tín',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235048/2021-2022/S%C3%B3ng%20IT/NQB_pe3d0b.jpg',
            title: 'Nguyễn Quốc Bảo',
        },
    ],
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235048/2021-2022/S%C3%B3ng%20IT/NDS_o963jv.jpg',
            title: 'Nguyễn Đức Sáng',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235048/2021-2022/S%C3%B3ng%20IT/NNT_irqymo.jpg',
            title: 'Nguyễn Như Tú',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235047/2021-2022/S%C3%B3ng%20IT/LTMN_tjxgkc.jpg',
            title: 'Lê Thị Minh Nguyệt',
        },
    ],
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235047/2021-2022/S%C3%B3ng%20IT/HTTV_seq6cp.jpg',
            title: 'Huỳnh Thị Thúy Vy',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235047/2021-2022/S%C3%B3ng%20IT/BAD_wkbghq.jpg',
            title: 'Bùi Anh Đức',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235047/2021-2022/S%C3%B3ng%20IT/HHH_wvdy0i.jpg',
            title: 'Hồ Huy Hoàng',
        },
    ],
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235047/2021-2022/S%C3%B3ng%20IT/DTL_cjeum6.jpg',
            title: 'Diệp Tấn Luân',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235047/2021-2022/S%C3%B3ng%20IT/DVT_ep9ycb.jpg',
            title: 'Đào Văn Thắng',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235046/2021-2022/S%C3%B3ng%20IT/DBT_mevfis.jpg',
            title: 'Diệp Bảo Tùng',
        },
    ],
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235046/2021-2022/S%C3%B3ng%20IT/TNMT_wxerbh.jpg',
            title: 'Trần Ngọc Minh Thiện',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235046/2021-2022/S%C3%B3ng%20IT/VHKD_eayevu.jpg',
            title: 'Võ Hoàng Khả Diệu',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648235046/2021-2022/S%C3%B3ng%20IT/TTLX_zoz98o.jpg',
            title: 'Trần Thị Lệ Xuân',
        },
    ],
]